import React from 'react';
import { AppProps } from 'next/app';
import { Global, css } from '@emotion/react';

import { initializeRum } from '../utils/datadogRum';

import { PageDataProvider } from '../context/PageData';
import { OptimizelyProvider } from '../context/Optimizely';
import { SubscriptionsProvider } from '../context/Subscriptions';
import { ViralLoopsDataProvider } from '../context/ViralLoops';

import { ThemeProvider } from '../theme';
import { GreenlightTheme } from '../theme/themes/greenlight';

import { glNormalize } from '../components/Metadata/gl-normalize.styles';

import '@/styles/normalize.css';
import '@/fonts/style.css';

initializeRum();

export default function App({ Component, pageProps }: AppProps) {
  return (
    <PageDataProvider {...pageProps}>
      <OptimizelyProvider {...pageProps}>
        <SubscriptionsProvider>
          <ViralLoopsDataProvider>
            <ThemeProvider theme={GreenlightTheme}>
              <Global
                styles={css`
                  ${glNormalize(GreenlightTheme)}
                `}
              />
              <Component {...pageProps} />
            </ThemeProvider>
          </ViralLoopsDataProvider>
        </SubscriptionsProvider>
      </OptimizelyProvider>
    </PageDataProvider>
  );
}

// export function reportWebVitals(metric: NextWebVitalsMetric) {
//   logger.info({ metric });
// }
